<template>
  <div class="page close-picker">
    <div class="page-content">
			<page-nav-bar currentServiceName="MoneyRoad" :subNavTitle="editProfilePage_title" :closePage="isSmartphone"></page-nav-bar>
      <div class="layoutTop"/>
<div class="container-fluid">
  <div class="row">
    <div class="col-md-10 offset-md-1">
      <div class="panel21 panel-default">

        <div class="panel-heading">
          <h4 class="content-block labelAccordionForm">
            <i class="fa fa-address-card"></i>
            {{ $t('profilesPage.edit_prfl') }}
          </h4>
        </div>

        <form>
          <div class="form-group row" v-if="accountType === '2'">
  					<label class="col-4 col-sm-2 col-form-label">{{ $t('common.nme') }}</label>
            <div class="col-8 col-sm-10">
              <input class="form-control" :placeholder="editProfilePage_Name" type="text" v-model="accountName"></input>
            </div>
          </div>
          <div class="form-group row" v-if="accountType === '1'">
            <label class="col-4 col-sm-2 col-form-label">{{ $t('common.nme') }}</label>
            <div class="col-8 col-sm-10">
              <input class="form-control" :placeholder="editProfilePage_Name" type="text" v-model="accountName"></input>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-4 col-sm-2 col-form-label">{{ $t('common.adrs') }}</label>
            <div class="col-8 col-sm-10">
              <input class="form-control" :placeholder="editProfilePage_Address" type="text" v-model="accountAddress"></input>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-4 col-sm-2 col-form-label">{{ $t('common.cty') }}</label>
            <div class="col-8 col-sm-10">
  					 <input class="form-control" :placeholder="editProfilePage_City" type="text" v-model="accountCity"></input>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-4 col-sm-2 col-form-label">{{ $t('common.zp_code') }}</label>
            <div class="col-8 col-sm-10">
  					 <input class="form-control" :placeholder="editProfilePage_ZipCode" type="text" v-model="accountZipCode"></input>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">{{ $t('common.ctry') }}</label>
            <div class="item-after col-sm-3 form-group" v-bind:class="colorBottomButton">
              <a href="#" data-picker=".profileCountryListPicker" class="link open-picker button button-round button-inner-color buttonAccordionForm ">
              {{ $t('common.slct') }}
              </a>
            </div>
            <div class="col-sm-7">
              <input class="form-control"  v-if="this.accountCountry === ''" :placeholder="editProfilePage_Country"></input>
            <input class="form-control" v-else v-model="accountCountry"></input>
            </div>
          </div>
          <div class="form-group row" v-if="accountType === '1'">
            <label class="col-4 col-sm-2 col-form-label">{{ $t('common.lgl_frm') }}</label>
            <div class="col-8 col-sm-10">
              <input class="form-control" :placeholder="editProfilePage_LegalForm" type="text" v-model="accountLegalForm">
              </input>
            </div>
          </div>
          <div class="form-group row" v-if="accountType === '1'">
            <label class="col-4 col-sm-2 col-form-label">{{ $t('common.shr_cptl') }}</label>
            <div class="col-8 col-sm-10">
              <input class="form-control" :placeholder="editProfilePage_ShareCapital" type="text" v-model="accountAmountOfCapital">
              </input>
            </div>
          </div>
          <div class="form-group row" v-if="accountType === '1'">
            <label class="col-4 col-sm-2 col-form-label">{{ $t('common.tva_nbr') }}</label>
            <div class="col-8 col-sm-10">
              <input class="form-control" :placeholder="editProfilePage_TVAnumber" type="text" v-model="accountIdentifierTVA" >
              </input>
            </div>
          </div>
        </form>

      <div class="picker-modal profileCountryListPicker">
        <div class="toolbar">
          <div class="toolbar-inner">
            <div class="left"></div>
            <div class="right"><a href="#" class="close-picker" @click="profileCountryListPickerCloseButton">{{ $t('common.dne') }}</a></div>
          </div>
        </div>
        <div class="picker-modal-inner scrollablePicker">
          <f7-searchbar class="search"
            id="profileSearchCountry"
            cancel-link="Cancel"
            search-list=".profileCountryList"
            :placeholder="editProfilePage_Search"
            @searchbar:search="onSearch"
            @searchbar:clear="onClear">
          </f7-searchbar>
          <div class="list-block profileCountryList">
            <f7-list contacts class="profileCountryList">
              <f7-list-group v-for="(group, key) in filteredCountries" :key="key">
                <f7-list-item :title="key" group-title></f7-list-item>
                <li v-for="country in group" :value="country">
                  <label class="label-radio item-content">
                    <input type="radio" name="profileCountryPickerRadio" :value="country">
                    <div class="item-inner">
                      <div class="item-title">{{ country }}</div>
                    </div>
                  </label>
                </li>
              </f7-list-group>
            </f7-list>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-2 offset-md-9" v-bind:class="colorBottomButton">
    <button round title="Validate changes" class="button-action firstButtonMarginTop" @click="updateAccount">
      <i class="icon fa fa-save"></i>
      <span>{{ $t('common.sve') }}</span>
    </button>
  </div>
</div>
<div class="row">
  <div class="toolbarPageBottomBlank"></div>
</div>

</div>
</div>
</div>

		<!-- </f7-page> -->
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      isSmartphone: false,
      accountType: '',
      accountName: '',
      accountCompanyName: '',
      accountEmailReference: '',
      accountAddress: '',
      accountCity: '',
      accountZipCode: '',
      accountLegalForm: '',
      accountAmountOfCapital: '',
      accountIdentifierTVA: '',
      filterBy: '',
      accountCountry: '',
      countryAlphaTable: {
        A: ['Afghanistan', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan'],
        B: ['Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegowina', 'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burundi'],
        C: ['Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo', 'Congo, the Democratic Republic of the', 'Cook Islands', 'Costa Rica', "Cote d'Ivoire", 'Croatia (Hrvatska)', 'Cuba', 'Cyprus', 'Czech Republic'],
        D: ['Denmark', 'Djibouti', 'Dominica', 'Dominican Republic'],
        E: ['East Timor', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia'],
        F: ['Falkland Islands (Malvinas)', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Territories'],
        G: ['Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guam', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana'],
        H: ['Haiti', 'Heard and Mc Donald Islands', 'Holy See (Vatican City State)', 'Honduras', 'Hong Kong', 'Hungary'],
        I: ['Iceland', 'India', 'Indonesia', 'Iran (Islamic Republic of)', 'Iraq', 'Ireland', 'Israel', 'Italy'],
        J: ['Jamaica', 'Japan', 'Jordan'],
        K: ['Kazakhstan', 'Kenya', 'Kiribati', "Korea, Democratic People's Republic of", 'Korea, Republic of', 'Kuwait', 'Kyrgyzstan'],
        L: ["Lao, People's Democratic Republic", 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libyan Arab Jamahiriya', 'Liechtenstein', 'Lithuania', 'Luxembourg'],
        M: ['Macau', 'Macedonia, The Former Yugoslav Republic of', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia, Federated States of', 'Moldova, Republic of', 'Monaco', 'Mongolia', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar'],
        N: ['Namibia', 'Nauru', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway'],
        O: ['Oman'],
        P: ['Pakistan', 'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Romania', 'Russian Federation', 'Rwanda'],
        S: ['Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia (Slovak Republic)', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia and the South Sandwich Islands', 'Spain', 'Sri Lanka', 'St. Helena', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen Islands', 'Swaziland', 'Sweden', 'Switzerland', 'Syrian Arab Republic'],
        T: ['Taiwan, Province of China', 'Tajikistan', 'Tanzania, United Republic of', 'Thailand', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu'],
        U: ['Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands', 'Uruguay', 'Uzbekistan'],
        V: ['Vanuatu', 'Venezuela', 'Vietnam', 'Virgin Islands (British)', 'Virgin Islands (U.S.)'],
        W: ['Wallis and Futuna Islands', 'Western Sahara'],
        Y: ['Yemen', 'Yugoslavia'],
        Z: ['Zambia', 'Zimbabwe']
      }
    }
  },
  created () {
    this.editProfilePage_title = this.$i18n.t('profilesPage.edit_prfl')
    this.editProfilePage_Name = this.$i18n.t('common.nme')
    this.editProfilePage_Address = this.$i18n.t('common.adrs')
    this.editProfilePage_City = this.$i18n.t('common.cty')
    this.editProfilePage_ZipCode = this.$i18n.t('common.zp_code')
    this.editProfilePage_Country = this.$i18n.t('common.ctry')
    this.editProfilePage_LegalForm = this.$i18n.t('common.lgl_frm')
    this.editProfilePage_ShareCapital = this.$i18n.t('common.shr_cptl')
    this.editProfilePage_TVAnumber = this.$i18n.t('common.tva_nbr')
    this.editProfilePage_Search = this.$i18n.t('common.srch')
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    }
    this.accountType = this.$engine.user.get().type

    this.accountName = this.$engine.user.get().name
    this.accountAddress = this.$engine.user.get().address
    this.accountCity = this.$engine.user.get().city
    this.accountZipCode = this.$engine.user.get().zip_code
    this.accountCountry = this.$engine.user.get().country
    this.accountLegalForm = this.$engine.user.get().legalForm
    this.accountAmountOfCapital = this.$engine.user.get().amountOfCapital
    this.accountIdentifierTVA = this.$engine.user.get().identifierTVA
  },
  computed: {
    filteredCountries () {
      let that = this
      let result = {}
      if (this.filterBy) {
        for (var k in that.countryAlphaTable) {
          for (var i = 0; i < that.countryAlphaTable[k].length; i++) {
            if (that.countryAlphaTable[k][i].toLowerCase().startsWith(this.filterBy.toLowerCase())) {
              if (!result.hasOwnProperty(k)) {
                result[k] = []
              }
              result[k].push(that.countryAlphaTable[k][i])
            }
          }
        }
        this.Dom7('li[class=hidden-by-searchbar]').each(function () {
          that.Dom7(this).removeClass('hidden-by-searchbar')
        })
        return result
      }

      return this.countryAlphaTable
    }
  },
  methods: {
    updateAccount () {
      let that = this
      that.$engine.accounts.update({
        idAccount: that.$engine.user.get().id,
        name: that.accountName,
        type: that.accountType,
        address: that.accountAddress,
        city: that.accountCity,
        zip_code: that.accountZipCode,
        email_reference: that.$engine.user.get().email_reference,
        country: that.accountCountry,
        legalForm: that.accountLegalForm,
        amountOfCapital: that.accountAmountOfCapital,
        identifierTVA: that.accountIdentifierTVA
      })
      .then(response => {
        if (response.status === 200) {
          // return that.model.get()
          this.$bus.$emit('refresh-cache-menu')

          that.$f7.modal({
            title: 'Profile modified',
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            // that.$bus.$emit('refresh-cache-account-members')
            loadPage(that, {url: '/profile/', force: false, ignoreCache: false})
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    profileCountryListPickerCloseButton () {
      if (this.Dom7('input[name=profileCountryPickerRadio]:checked').val() !== undefined) {
        this.accountCountry = this.Dom7('input[name=profileCountryPickerRadio]:checked').val()
      }
    },
    onSearch: function (query, found) {
      this.filterBy = query
    },
    onClear: function () {
      this.filterBy = ''
    }
  }
}
</script>
<style scoped>
#profileSearchCountry {
  margin-top: 0;
}
.search {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// CMProfileEdit.vue?6e562da2